export default __webpack_public_path__ + "static/media/image.e50413ca.svg";